// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file achievements.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file achievements.proto.
 */
export const file_achievements: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * This file defines all achievements that can be obtained by a heylogin user.
 *
 * For achievement naming strategy:
 *  - achievements are prefixed with the component prefix that generates them
 *  - achievements are present tense
 *  - each achievement is named precisely for the technical event that triggers it
 *
 *  NOTE: Achievements must never be removed from this file!
 *
 * @generated from enum domain.Achievement
 */
export enum Achievement {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * bae
   * Granted on user account creation from an android client.
   *
   * @generated from enum value: BAE_REGISTER_ANDROID = 1;
   */
  BAE_REGISTER_ANDROID = 1,

  /**
   * Granted on user account creation from an ios client.
   *
   * @generated from enum value: BAE_REGISTER_IOS = 2;
   */
  BAE_REGISTER_IOS = 2,

  /**
   * Granted on user account creation from web (likely webauthn).
   *
   * @generated from enum value: BAE_REGISTER_WEB = 11;
   */
  BAE_REGISTER_WEB = 11,

  /**
   * Granted on user account creation from backup client.
   *
   * @generated from enum value: BAE_REGISTER_BAK = 12;
   */
  BAE_REGISTER_BAK = 12,

  /**
   * Granted when an account is marked for deletion due to inactivity
   *
   * @generated from enum value: BAE_INACTIVE_MARKED_FOR_DELETION = 3;
   */
  BAE_INACTIVE_MARKED_FOR_DELETION = 3,

  /**
   * Granted when the account was marked for deletion, then has been reactivated
   *
   * @generated from enum value: BAE_REACTIVATED = 4;
   */
  BAE_REACTIVATED = 4,

  /**
   * Granted when the account created an organization, and an icon was automatically found.
   *
   * @generated from enum value: BAE_ORG_ICON_FOUND = 5;
   */
  BAE_ORG_ICON_FOUND = 5,

  /**
   * User logged in with recovery authenticator
   *
   * @generated from enum value: BAE_LOGIN_RECOVERY = 6;
   */
  BAE_LOGIN_RECOVERY = 6,

  /**
   * User logged in with backup authenticator
   *
   * @generated from enum value: BAE_LOGIN_BACKUP = 7;
   */
  BAE_LOGIN_BACKUP = 7,

  /**
   * User deleted a private profile
   *
   * @generated from enum value: BAE_PRIVATE_PROFILE_DELETE = 8;
   */
  BAE_PRIVATE_PROFILE_DELETE = 8,

  /**
   * User created a login inbox
   *
   * @generated from enum value: BAE_LOGIN_INBOX_CREATE = 9;
   */
  BAE_LOGIN_INBOX_CREATE = 9,

  /**
   * Someone sent a login to a login inbox of this user
   *
   * @generated from enum value: BAE_LOGIN_INBOX_MESSAGE = 10;
   */
  BAE_LOGIN_INBOX_MESSAGE = 10,

  /**
   * and
   * Granted after the autofill setup screen has been shown to the user.
   *
   * @generated from enum value: AND_AUTOFILL_SETUP = 1000000;
   */
  AND_AUTOFILL_SETUP = 1000000,

  /**
   * Granted after the user has enabled autofill.
   *
   * @generated from enum value: AND_AUTOFILL_ENABLE = 1000001;
   */
  AND_AUTOFILL_ENABLE = 1000001,

  /**
   * Granted after autofill inserted a login into another app.
   *
   * @generated from enum value: AND_AUTOFILL_INSERT = 1000002;
   */
  AND_AUTOFILL_INSERT = 1000002,

  /**
   * Granted when a login is updated after accepting the "Update password?"" dialog shown after an
   * autofilled password has been changed before submission.
   *
   * @generated from enum value: AND_AUTOFILL_UPDATE = 1000003;
   */
  AND_AUTOFILL_UPDATE = 1000003,

  /**
   * Granted after a regular cloud backup has been created.
   *
   * @generated from enum value: AND_BACKUP_REGULAR = 1000100;
   */
  AND_BACKUP_REGULAR = 1000100,

  /**
   * Granted after an end2end encrypted cloud backup has been created.
   *
   * @generated from enum value: AND_BACKUP_E2E = 1000101;
   */
  AND_BACKUP_E2E = 1000101,

  /**
   * Granted after a transfer backup has been created.
   *
   * @generated from enum value: AND_BACKUP_TRANSFER = 1000102;
   */
  AND_BACKUP_TRANSFER = 1000102,

  /**
   * Granted after the conditions to show the "please review" screen are fulfilled:
   * at least 5 swipe to logins during the last 7 days.
   *
   * @generated from enum value: AND_REVIEW_CONDITIONS_FULFILLED = 1000200;
   */
  AND_REVIEW_CONDITIONS_FULFILLED = 1000200,

  /**
   * Granted after the review dialog has been shown.
   * Note that the play store API doesn't give us exact information, so we can only guess the review
   * dialog was shown to the user based on timing info.
   *
   * @generated from enum value: AND_REVIEW_SHOWN = 1000201;
   */
  AND_REVIEW_SHOWN = 1000201,

  /**
   * Granted after the review dialog was open for at least three seconds.
   *
   * @generated from enum value: AND_REVIEW_STAYED_3_SECONDS = 1000202;
   */
  AND_REVIEW_STAYED_3_SECONDS = 1000202,

  /**
   * Granted after the app requested the camera permission.
   *
   * @generated from enum value: AND_SCAN_CAMERA_REQUESTED = 1000300;
   */
  AND_SCAN_CAMERA_REQUESTED = 1000300,

  /**
   * Granted after the app was granted the camera permission.
   *
   * @generated from enum value: AND_SCAN_CAMERA_GRANTED = 1000301;
   */
  AND_SCAN_CAMERA_GRANTED = 1000301,

  /**
   * Granted after the app scanned a heylogin login link.
   *
   * @generated from enum value: AND_SCAN_SCANNED = 1000302;
   */
  AND_SCAN_SCANNED = 1000302,

  /**
   * Granted after the app has been opened from an heylogin login link.
   *
   * @generated from enum value: AND_SCAN_FROM_EXTERNAL = 1000303;
   */
  AND_SCAN_FROM_EXTERNAL = 1000303,

  /**
   * Granted when the user was shown the "keystore lost" screen
   *
   * @generated from enum value: AND_KEYSTORE_LOST_SHOWN_NO_BACKUP = 1000400;
   */
  AND_KEYSTORE_LOST_SHOWN_NO_BACKUP = 1000400,

  /**
   * @generated from enum value: AND_KEYSTORE_LOST_SHOWN_BACKUP_AVAILABLE = 1000401;
   */
  AND_KEYSTORE_LOST_SHOWN_BACKUP_AVAILABLE = 1000401,

  /**
   * DEPRECATED: This group of achievements is now collected as part of Session.DeviceInfo
   * Granted when a user does not have a secure lock screen, but enforcement is not enabled
   *
   * @generated from enum value: AND_SECOND_FACTOR_ENFORCEMENT_GRANDFATHERED = 1000500 [deprecated = true];
   * @deprecated
   */
  AND_SECOND_FACTOR_ENFORCEMENT_GRANDFATHERED = 1000500,

  /**
   * Granted when the app was installed via an admin policy
   *
   * @generated from enum value: AND_INSTALLED_VIA_ADMIN_POLICY = 1000600 [deprecated = true];
   * @deprecated
   */
  AND_INSTALLED_VIA_ADMIN_POLICY = 1000600,

  /**
   * Granted when the app detects that an MDM provider is active on the user's device
   *
   * @generated from enum value: AND_HAS_RESTRICTIONS_PROVIDER = 1000601 [deprecated = true];
   * @deprecated
   */
  AND_HAS_RESTRICTIONS_PROVIDER = 1000601,

  /**
   * web
   * Granted after successfully creating a pairing.
   *
   * @generated from enum value: WEB_SESSION_CREATE = 2000000;
   */
  WEB_SESSION_CREATE = 2000000,

  /**
   * Granted after successfully unlocking a session.
   *
   * @generated from enum value: WEB_SESSION_UNLOCK = 2000001;
   */
  WEB_SESSION_UNLOCK = 2000001,

  /**
   * Granted when the user has a web session on a smartphone
   *
   * @generated from enum value: WEB_SESSION_PHONE = 2000010;
   */
  WEB_SESSION_PHONE = 2000010,

  /**
   * Granted when the user has a web session on a tablet
   *
   * @generated from enum value: WEB_SESSION_TABLET = 2000011;
   */
  WEB_SESSION_TABLET = 2000011,

  /**
   * All import achievements are granted after successfully importing from the specified product.
   *
   * @generated from enum value: WEB_IMPORT_HEYLOGIN = 2000100;
   */
  WEB_IMPORT_HEYLOGIN = 2000100,

  /**
   * @generated from enum value: WEB_IMPORT_BITWARDEN = 2000101;
   */
  WEB_IMPORT_BITWARDEN = 2000101,

  /**
   * @generated from enum value: WEB_IMPORT_LASTPASS = 2000102;
   */
  WEB_IMPORT_LASTPASS = 2000102,

  /**
   * @generated from enum value: WEB_IMPORT_CHROME = 2000103;
   */
  WEB_IMPORT_CHROME = 2000103,

  /**
   * @generated from enum value: WEB_IMPORT_FIREFOX = 2000104;
   */
  WEB_IMPORT_FIREFOX = 2000104,

  /**
   * @generated from enum value: WEB_IMPORT_DASHLANE = 2000105;
   */
  WEB_IMPORT_DASHLANE = 2000105,

  /**
   * @generated from enum value: WEB_IMPORT_ONEPASSWORD = 2000106;
   */
  WEB_IMPORT_ONEPASSWORD = 2000106,

  /**
   * @generated from enum value: WEB_IMPORT_KEEPASS = 2000107;
   */
  WEB_IMPORT_KEEPASS = 2000107,

  /**
   * @generated from enum value: WEB_IMPORT_SAFARI = 2000108;
   */
  WEB_IMPORT_SAFARI = 2000108,

  /**
   * @generated from enum value: WEB_IMPORT_NORDPASS = 2000109;
   */
  WEB_IMPORT_NORDPASS = 2000109,

  /**
   * @generated from enum value: WEB_IMPORT_STICKYPASSWORD = 2000110;
   */
  WEB_IMPORT_STICKYPASSWORD = 2000110,

  /**
   * @generated from enum value: WEB_IMPORT_CSV = 2000111;
   */
  WEB_IMPORT_CSV = 2000111,

  /**
   * @generated from enum value: WEB_IMPORT_EXCEL = 2000112;
   */
  WEB_IMPORT_EXCEL = 2000112,

  /**
   * @generated from enum value: WEB_IMPORT_ENPASS = 2000113;
   */
  WEB_IMPORT_ENPASS = 2000113,

  /**
   * @generated from enum value: WEB_IMPORT_PROTONPASS = 2000114;
   */
  WEB_IMPORT_PROTONPASS = 2000114,

  /**
   * @generated from enum value: WEB_IMPORT_KEEPER = 2000115;
   */
  WEB_IMPORT_KEEPER = 2000115,

  /**
   * Granted after an export has been generated.
   *
   * @generated from enum value: WEB_EXPORT = 2000200;
   */
  WEB_EXPORT = 2000200,

  /**
   * Granted after a login has been added manually to a vault.
   * TODO: Restrict to private vaults only?
   *
   * @generated from enum value: WEB_LOGIN_ADD = 2000300;
   */
  WEB_LOGIN_ADD = 2000300,

  /**
   * Granted after the first login has been added manually to an empty vault.
   * TODO: Restrict to private vaults only?
   *
   * @generated from enum value: WEB_LOGIN_ADD_FIRST_MANUAL = 2000301;
   */
  WEB_LOGIN_ADD_FIRST_MANUAL = 2000301,

  /**
   * Granted after CTRL/CMD-K has been pressed to focus the search field.
   *
   * @generated from enum value: WEB_USE_SEARCH_SHORTCUT = 2000302;
   */
  WEB_USE_SEARCH_SHORTCUT = 2000302,

  /**
   * Granted on creation of the first share link
   *
   * @generated from enum value: WEB_LOGIN_CREATE_SHARE_LINK = 2000303;
   */
  WEB_LOGIN_CREATE_SHARE_LINK = 2000303,

  /**
   * Granted when the paddle subscribe modal is opened
   *
   * @generated from enum value: WEB_PADDLE_SUBSCRIBE_OPENED = 2000400;
   */
  WEB_PADDLE_SUBSCRIBE_OPENED = 2000400,

  /**
   * Granted when the the paddle paddle subscribe modal is closed without purchase
   *
   * @generated from enum value: WEB_PADDLE_SUBSCRIBE_CLOSED = 2000401;
   */
  WEB_PADDLE_SUBSCRIBE_CLOSED = 2000401,

  /**
   * Granted when the the paddle paddle subscribe modal is completed with purchase
   *
   * @generated from enum value: WEB_PADDLE_SUBSCRIBE_COMPLETED = 2000402;
   */
  WEB_PADDLE_SUBSCRIBE_COMPLETED = 2000402,

  /**
   * Granted when the paddle manage modal is opened
   *
   * @generated from enum value: WEB_PADDLE_MANAGE_OPENED = 2000420;
   */
  WEB_PADDLE_MANAGE_OPENED = 2000420,

  /**
   * Granted when the the paddle paddle manage modal is closed without purchase
   *
   * @generated from enum value: WEB_PADDLE_MANAGE_CLOSED = 2000421;
   */
  WEB_PADDLE_MANAGE_CLOSED = 2000421,

  /**
   * Granted when the the paddle paddle manage modal is completed with purchase
   *
   * @generated from enum value: WEB_PADDLE_MANAGE_COMPLETED = 2000422;
   */
  WEB_PADDLE_MANAGE_COMPLETED = 2000422,

  /**
   * Granted when creating an organization
   *
   * @generated from enum value: WEB_ORGANIZATION_CREATE = 2000500;
   */
  WEB_ORGANIZATION_CREATE = 2000500,

  /**
   * Grantend when joining an organization
   *
   * @generated from enum value: WEB_ORGANIZATION_JOIN = 2000501;
   */
  WEB_ORGANIZATION_JOIN = 2000501,

  /**
   * Grantend to an organization admin for accessing a user's personal vault
   *
   * @generated from enum value: WEB_ORGANIZATION_ADMIN_ACCESS_PERSONAL = 2000502;
   */
  WEB_ORGANIZATION_ADMIN_ACCESS_PERSONAL = 2000502,

  /**
   * Grantend for adding a new user with an existing heylogin account to an organization
   *
   * @generated from enum value: WEB_ORGANIZATION_USER_ADD_EXISTING = 2000510;
   */
  WEB_ORGANIZATION_USER_ADD_EXISTING = 2000510,

  /**
   * Grantend for removing a user with an existing heylogin account from an organization
   *
   * @generated from enum value: WEB_ORGANIZATION_USER_REMOVE_EXISTING = 2000511;
   */
  WEB_ORGANIZATION_USER_REMOVE_EXISTING = 2000511,

  /**
   * Grantend for adding a new user with no existing heylogin account to an organization
   *
   * @generated from enum value: WEB_ORGANIZATION_USER_ADD_NEW = 2000512;
   */
  WEB_ORGANIZATION_USER_ADD_NEW = 2000512,

  /**
   * Grantend for removing a user with no existing heylogin account from an organization
   *
   * @generated from enum value: WEB_ORGANIZATION_USER_REMOVE_NEW = 2000513;
   */
  WEB_ORGANIZATION_USER_REMOVE_NEW = 2000513,

  /**
   * Grantend for changing a organization user's access level
   *
   * @generated from enum value: WEB_ORGANIZATION_USER_CHANGE_ACCESS_LEVEL = 2000514;
   */
  WEB_ORGANIZATION_USER_CHANGE_ACCESS_LEVEL = 2000514,

  /**
   * Grantend for creating a team inside an organization
   *
   * @generated from enum value: WEB_ORGANIZATION_TEAM_CREATE = 2000520;
   */
  WEB_ORGANIZATION_TEAM_CREATE = 2000520,

  /**
   * ext
   * Granted after the extension has been installed.
   *
   * @generated from enum value: EXT_INSTALL = 3000000;
   */
  EXT_INSTALL = 3000000,

  /**
   * Granted after the user has disabled the extension for a page.
   *
   * @generated from enum value: EXT_DISABLE_FOR_PAGE = 3000001;
   */
  EXT_DISABLE_FOR_PAGE = 3000001,

  /**
   * Granted when the user reports a page to heyproblems 
   *
   * @generated from enum value: EXT_REPORT_PAGE = 3000002;
   */
  EXT_REPORT_PAGE = 3000002,

  /**
   * Granted when the extension creates a new login.
   *
   * @generated from enum value: EXT_LOGIN_INSERT = 3000100;
   */
  EXT_LOGIN_INSERT = 3000100,

  /**
   * Granted when the extension updates an existing login.
   *
   * @generated from enum value: EXT_LOGIN_UPDATE = 3000101;
   */
  EXT_LOGIN_UPDATE = 3000101,

  /**
   * Granted when a login form has been detected and a user manually logs in and we autosnatch that
   * login.
   *
   * @generated from enum value: EXT_AUTOSNATCH_FROM_LOGIN = 3000110;
   */
  EXT_AUTOSNATCH_FROM_LOGIN = 3000110,

  /**
   * DEPRECATED: we no longer autosnatch from registration forms
   * Granted when a registration form has been detected and we autosnatched that login.
   *
   * @generated from enum value: EXT_AUTOSNATCH_FROM_REGISTRATION = 3000111 [deprecated = true];
   * @deprecated
   */
  EXT_AUTOSNATCH_FROM_REGISTRATION = 3000111,

  /**
   * Granted after the user clicked on a login in the overlay and it logged them in.
   *
   * @generated from enum value: EXT_OVERLAY_LOGIN = 3000200;
   */
  EXT_OVERLAY_LOGIN = 3000200,

  /**
   * Granted after the user clicked on a login but the extension was locked and the user has now
   * unlocked it.
   *
   * @generated from enum value: EXT_OVERLAY_UNLOCK = 3000201;
   */
  EXT_OVERLAY_UNLOCK = 3000201,

  /**
   * DEPRECATED: We no longer do this
   *
   * @generated from enum value: EXT_OVERLAY_NEW_LOGIN = 3000202 [deprecated = true];
   * @deprecated
   */
  EXT_OVERLAY_NEW_LOGIN = 3000202,

  /**
   * @generated from enum value: EXT_OVERLAY_NEW_LOGIN_FROM_PENDING_REGISTRATION = 3000203 [deprecated = true];
   * @deprecated
   */
  EXT_OVERLAY_NEW_LOGIN_FROM_PENDING_REGISTRATION = 3000203,

  /**
   * Granted after updating a login that only contained a generated password from the overlay.
   *
   * @generated from enum value: EXT_OVERLAY_UPDATE_GENERATED_PASSWORD = 3000204;
   */
  EXT_OVERLAY_UPDATE_GENERATED_PASSWORD = 3000204,

  /**
   * Granted when the user disables autosnatch form the autosnatch overlay
   *
   * @generated from enum value: EXT_OVERLAY_DISABLE_AUTOSNATCH = 3000004;
   */
  EXT_OVERLAY_DISABLE_AUTOSNATCH = 3000004,

  /**
   * Granted when subscription nag screen is displayed to the user
   *
   * @generated from enum value: EXT_OVERLAY_SAW_NAG_SCREEN = 3000005;
   */
  EXT_OVERLAY_SAW_NAG_SCREEN = 3000005,

  /**
   * Granted when opening the extension popup.
   *
   * @generated from enum value: EXT_POPUP_OPEN = 3000300;
   */
  EXT_POPUP_OPEN = 3000300,

  /**
   * Granted when opening the extension popup but the extension was locked and the user has now
   * unlocked it.
   *
   * @generated from enum value: EXT_POPUP_UNLOCK = 3000301;
   */
  EXT_POPUP_UNLOCK = 3000301,

  /**
   * Granted when the user disables autosnatch from the popup
   *
   * @generated from enum value: EXT_POPUP_DISABLE_AUTOSNATCH = 3000003;
   */
  EXT_POPUP_DISABLE_AUTOSNATCH = 3000003,

  /**
   * Granted after searching for a login
   *
   * @generated from enum value: EXT_OMNIBOX_INPUT_CHANGED = 3000400;
   */
  EXT_OMNIBOX_INPUT_CHANGED = 3000400,

  /**
   * Granted after pressing enter on an omnibox login
   *
   * @generated from enum value: EXT_OMNIBOX_INPUT_ENTERED = 3000401;
   */
  EXT_OMNIBOX_INPUT_ENTERED = 3000401,

  /**
   * All achievements are granted after the respective operation has been performed from the context
   * menu.
   * Granted after enabling the extension for the page via the context menu.
   *
   * @generated from enum value: EXT_CONTEXT_MENU_HEYLOGIN_ENABLED = 3000500;
   */
  EXT_CONTEXT_MENU_HEYLOGIN_ENABLED = 3000500,

  /**
   * @generated from enum value: EXT_CONTEXT_MENU_USERNAME_FILLED = 3000510;
   */
  EXT_CONTEXT_MENU_USERNAME_FILLED = 3000510,

  /**
   * @generated from enum value: EXT_CONTEXT_MENU_PASSWORD_FILLED = 3000511;
   */
  EXT_CONTEXT_MENU_PASSWORD_FILLED = 3000511,

  /**
   * @generated from enum value: EXT_CONTEXT_MENU_CUSTOM_TOTP_FILLED = 3000512;
   */
  EXT_CONTEXT_MENU_CUSTOM_TOTP_FILLED = 3000512,

  /**
   * @generated from enum value: EXT_CONTEXT_MENU_CUSTOM_PLAIN_FILLED = 3000513;
   */
  EXT_CONTEXT_MENU_CUSTOM_PLAIN_FILLED = 3000513,

  /**
   * @generated from enum value: EXT_CONTEXT_MENU_CUSTOM_PROTECTED_FILLED = 3000514;
   */
  EXT_CONTEXT_MENU_CUSTOM_PROTECTED_FILLED = 3000514,

  /**
   * Granted after opening the global search window
   *
   * @generated from enum value: EXT_GLOBAL_SEARCH_OPEN = 3000600;
   */
  EXT_GLOBAL_SEARCH_OPEN = 3000600,

  /**
   * Granted when opening the global search window but the extension was locked and the user has now
   * unlocked it.
   *
   * @generated from enum value: EXT_GLOBAL_SEARCH_UNLOCK = 3000601;
   */
  EXT_GLOBAL_SEARCH_UNLOCK = 3000601,

  /**
   * Granted when autotype (autohotkey version) was installed
   *
   * @generated from enum value: EXT_LEGACY_AUTOTYPE_INSTALLED = 3000700;
   */
  EXT_LEGACY_AUTOTYPE_INSTALLED = 3000700,

  /**
   * Granted when autotype was installed
   *
   * @generated from enum value: EXT_AUTOTYPE_INSTALLED = 3000701;
   */
  EXT_AUTOTYPE_INSTALLED = 3000701,

  /**
   * @generated from enum value: EXT_AUTOTYPE_USED_ACCELERATOR = 3000702;
   */
  EXT_AUTOTYPE_USED_ACCELERATOR = 3000702,

  /**
   * Granted when the user opens the fullscreen overlay
   *
   * @generated from enum value: EXT_FULLSCREEN_OVERLAY_OPEN = 3000800;
   */
  EXT_FULLSCREEN_OVERLAY_OPEN = 3000800,

  /**
   * Granted after the user clicked on a login in the fullscreen overlay but the extension was
   * locked and the user has now unlocked it.
   *
   * @generated from enum value: EXT_FULLSCREEN_OVERLAY_UNLOCK = 3000801;
   */
  EXT_FULLSCREEN_OVERLAY_UNLOCK = 3000801,

  /**
   * Granted when the get passkey overlay is shown to the user
   *
   * @generated from enum value: EXT_PASSKEY_GET_OVERLAY_OPEN = 3000900;
   */
  EXT_PASSKEY_GET_OVERLAY_OPEN = 3000900,

  /**
   * Granted when the get passkey overlay is canceled by the user
   *
   * @generated from enum value: EXT_PASSKEY_GET_OVERLAY_CANCEL = 3000901;
   */
  EXT_PASSKEY_GET_OVERLAY_CANCEL = 3000901,

  /**
   * Granted when the user decides to use a security key instead of heylogin
   * when using a passkey
   *
   * @generated from enum value: EXT_PASSKEY_GET_OVERLAY_USE_SECURITY_KEY = 3000902;
   */
  EXT_PASSKEY_GET_OVERLAY_USE_SECURITY_KEY = 3000902,

  /**
   * Note that we do not display errors in the passkey get ui; therefore we omit
   * the corresponding achievement.
   * Granted when an overlay was not opened because an overlay was already open
   *
   * @generated from enum value: EXT_PASSKEY_GET_OVERLAY_ALREADY_OPEN = 3000904;
   */
  EXT_PASSKEY_GET_OVERLAY_ALREADY_OPEN = 3000904,

  /**
   * Granted when an unlock in the get passkey overlay was successful
   *
   * @generated from enum value: EXT_PASSKEY_GET_OVERLAY_UNLOCK = 3000905;
   */
  EXT_PASSKEY_GET_OVERLAY_UNLOCK = 3000905,

  /**
   * Granted when the create passkey overlay is shown to the user
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_OVERLAY_OPEN = 3000910;
   */
  EXT_PASSKEY_CREATE_OVERLAY_OPEN = 3000910,

  /**
   * Granted when the create passkey overlay is canceled by the user
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_OVERLAY_CANCEL = 3000911;
   */
  EXT_PASSKEY_CREATE_OVERLAY_CANCEL = 3000911,

  /**
   * Granted when the user decides to use a security key instead of heylogin
   * when creating a new passkey
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_OVERLAY_USE_SECURITY_KEY = 3000912;
   */
  EXT_PASSKEY_CREATE_OVERLAY_USE_SECURITY_KEY = 3000912,

  /**
   * Granted when an error during the passkey creation was surfaced to the user
   * as a generic error in the overlay
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_OVERLAY_SHOW_ERROR = 3000913;
   */
  EXT_PASSKEY_CREATE_OVERLAY_SHOW_ERROR = 3000913,

  /**
   * Granted when an overlay was not opened because an overlay was already open
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_OVERLAY_ALREADY_OPEN = 3000914;
   */
  EXT_PASSKEY_CREATE_OVERLAY_ALREADY_OPEN = 3000914,

  /**
   * Granted when an unlock in the create passkey overlay was successful
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_OVERLAY_UNLOCK = 3000915;
   */
  EXT_PASSKEY_CREATE_OVERLAY_UNLOCK = 3000915,

  /**
   * Granted when a passkey is created 
   *
   * @generated from enum value: EXT_PASSKEY_CREATE = 3000920;
   */
  EXT_PASSKEY_CREATE = 3000920,

  /**
   * @generated from enum value: EXT_PASSKEY_CREATE_EC = 3000921;
   */
  EXT_PASSKEY_CREATE_EC = 3000921,

  /**
   * @generated from enum value: EXT_PASSKEY_CREATE_RSA = 3000922;
   */
  EXT_PASSKEY_CREATE_RSA = 3000922,

  /**
   * @generated from enum value: EXT_PASSKEY_CREATE_OKP = 3000923;
   */
  EXT_PASSKEY_CREATE_OKP = 3000923,

  /**
   * Granted when a passkey is used 
   *
   * @generated from enum value: EXT_PASSKEY_GET = 3000930;
   */
  EXT_PASSKEY_GET = 3000930,

  /**
   * @generated from enum value: EXT_PASSKEY_GET_EC = 3000931;
   */
  EXT_PASSKEY_GET_EC = 3000931,

  /**
   * @generated from enum value: EXT_PASSKEY_GET_RSA = 3000932;
   */
  EXT_PASSKEY_GET_RSA = 3000932,

  /**
   * @generated from enum value: EXT_PASSKEY_GET_OKP = 3000933;
   */
  EXT_PASSKEY_GET_OKP = 3000933,

  /**
   * Granted when the API is called with a request to use a passkey
   *
   * @generated from enum value: EXT_PASSKEY_GET_REQUEST = 3000940;
   */
  EXT_PASSKEY_GET_REQUEST = 3000940,

  /**
   * Granted when the API is called with a request to create a passkey
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_REQUEST = 3000941;
   */
  EXT_PASSKEY_CREATE_REQUEST = 3000941,

  /**
   * Granted when a passkey get request is initiated using conditional mediation
   *
   * @generated from enum value: EXT_PASSKEY_GET_REQUEST_MEDIATION_CONDITIONAL = 3000950;
   */
  EXT_PASSKEY_GET_REQUEST_MEDIATION_CONDITIONAL = 3000950,

  /**
   * Granted when a passkey get request is initiated using silent mediation
   *
   * @generated from enum value: EXT_PASSKEY_GET_REQUEST_MEDIATION_SILENT = 3000951;
   */
  EXT_PASSKEY_GET_REQUEST_MEDIATION_SILENT = 3000951,

  /**
   * Granted when a passkey get request is initiated using optional mediation
   *
   * @generated from enum value: EXT_PASSKEY_GET_REQUEST_MEDIATION_OPTIONAL = 3000952;
   */
  EXT_PASSKEY_GET_REQUEST_MEDIATION_OPTIONAL = 3000952,

  /**
   * Granted when a passkey get request is initiated using required mediation
   *
   * @generated from enum value: EXT_PASSKEY_GET_REQUEST_MEDIATION_REQUIRED = 3000953;
   */
  EXT_PASSKEY_GET_REQUEST_MEDIATION_REQUIRED = 3000953,

  /**
   * Granted when a passkey get request is rejected due to failed
   * isValidRpId check
   *
   * @generated from enum value: EXT_PASSKEY_GET_REQUEST_REJECT_NO_VALID_RP_ID = 3000954;
   */
  EXT_PASSKEY_GET_REQUEST_REJECT_NO_VALID_RP_ID = 3000954,

  /**
   * Granted when a passkey get request is rejected because another concurrent
   * request is already active
   *
   * @generated from enum value: EXT_PASSKEY_GET_REQUEST_REJECT_CONCURRENT_OPERATION = 3000955;
   */
  EXT_PASSKEY_GET_REQUEST_REJECT_CONCURRENT_OPERATION = 3000955,

  /**
   * Granted when a passkey get request is rejected due to a parse error of the
   * request
   *
   * @generated from enum value: EXT_PASSKEY_GET_REQUEST_PARSE_ERROR = 3000956;
   */
  EXT_PASSKEY_GET_REQUEST_PARSE_ERROR = 3000956,

  /**
   * Granted when a passkey get request is aborted before completion
   *
   * @generated from enum value: EXT_PASSKEY_GET_REQUEST_ABORT = 3000957;
   */
  EXT_PASSKEY_GET_REQUEST_ABORT = 3000957,

  /**
   * Granted when a passkey attestation is authorized through related origins
   *
   * @generated from enum value: EXT_PASSKEY_GET_REQUEST_SUCCEED_RELATED_ORIGINS = 3000958;
   */
  EXT_PASSKEY_GET_REQUEST_SUCCEED_RELATED_ORIGINS = 3000958,

  /**
   * Granted when a passkey attestation fails due to related origins
   *
   * @generated from enum value: EXT_PASSKEY_GET_REQUEST_FAIL_RELATED_ORIGINS = 3000959;
   */
  EXT_PASSKEY_GET_REQUEST_FAIL_RELATED_ORIGINS = 3000959,

  /**
   * Granted when a passkey create request is initiated using conditional mediation
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_REQUEST_MEDIATION_CONDITIONAL = 3000960;
   */
  EXT_PASSKEY_CREATE_REQUEST_MEDIATION_CONDITIONAL = 3000960,

  /**
   * Granted when a passkey create request is initiated using silent mediation
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_REQUEST_MEDIATION_SILENT = 3000961;
   */
  EXT_PASSKEY_CREATE_REQUEST_MEDIATION_SILENT = 3000961,

  /**
   * Granted when a passkey create request is initiated using optional mediation
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_REQUEST_MEDIATION_OPTIONAL = 3000962;
   */
  EXT_PASSKEY_CREATE_REQUEST_MEDIATION_OPTIONAL = 3000962,

  /**
   * Granted when a passkey create request is initiated using required mediation
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_REQUEST_MEDIATION_REQUIRED = 3000963;
   */
  EXT_PASSKEY_CREATE_REQUEST_MEDIATION_REQUIRED = 3000963,

  /**
   * Granted when a passkey create request is rejected due to failed
   * isValidRpId check
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_REQUEST_REJECT_NO_VALID_RP_ID = 3000964;
   */
  EXT_PASSKEY_CREATE_REQUEST_REJECT_NO_VALID_RP_ID = 3000964,

  /**
   * Granted when a passkey create request is rejected because another
   * concurrent request is already active
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_REQUEST_REJECT_CONCURRENT_OPERATION = 3000965;
   */
  EXT_PASSKEY_CREATE_REQUEST_REJECT_CONCURRENT_OPERATION = 3000965,

  /**
   * Granted when a passkey create request is rejected due to a parse error of
   * the request
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_REQUEST_PARSE_ERROR = 3000966;
   */
  EXT_PASSKEY_CREATE_REQUEST_PARSE_ERROR = 3000966,

  /**
   * Granted when a passkey create request is aborted before completion
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_REQUEST_ABORT = 3000967;
   */
  EXT_PASSKEY_CREATE_REQUEST_ABORT = 3000967,

  /**
   * Granted when a passkey creation is authorized through related origins
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_REQUEST_SUCCEED_RELATED_ORIGINS = 3000968;
   */
  EXT_PASSKEY_CREATE_REQUEST_SUCCEED_RELATED_ORIGINS = 3000968,

  /**
   * Granted when a passkey creation fails due to related origins
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_REQUEST_FAIL_RELATED_ORIGINS = 3000969;
   */
  EXT_PASSKEY_CREATE_REQUEST_FAIL_RELATED_ORIGINS = 3000969,

  /**
   * Granted when a passkey get successfully uses conditional mediation
   *
   * @generated from enum value: EXT_PASSKEY_GET_MEDIATION_CONDITIONAL = 3000970;
   */
  EXT_PASSKEY_GET_MEDIATION_CONDITIONAL = 3000970,

  /**
   * Note that we do not support nor plan to support silent mediation; therefore
   * we omit the corresponding achievement.
   * Granted when a passkey get successfully uses optional mediation
   *
   * @generated from enum value: EXT_PASSKEY_GET_MEDIATION_OPTIONAL = 3000972;
   */
  EXT_PASSKEY_GET_MEDIATION_OPTIONAL = 3000972,

  /**
   * Granted when a passkey get successfully uses required mediation
   *
   * @generated from enum value: EXT_PASSKEY_GET_MEDIATION_REQUIRED = 3000973;
   */
  EXT_PASSKEY_GET_MEDIATION_REQUIRED = 3000973,

  /**
   * Granted when a passkey is successfully created using conditional mediation
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_MEDIATION_CONDITIONAL = 3000980;
   */
  EXT_PASSKEY_CREATE_MEDIATION_CONDITIONAL = 3000980,

  /**
   * Note that we do not support nor plan to support silent mediation; therefore
   * we omit the corresponding achievement.
   * Granted when a passkey is successfully created using optional mediation
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_MEDIATION_OPTIONAL = 3000982;
   */
  EXT_PASSKEY_CREATE_MEDIATION_OPTIONAL = 3000982,

  /**
   * Granted when a passkey is successfully created using required mediation
   *
   * @generated from enum value: EXT_PASSKEY_CREATE_MEDIATION_REQUIRED = 3000983;
   */
  EXT_PASSKEY_CREATE_MEDIATION_REQUIRED = 3000983,

  /**
   * cor
   * All achievements are granted after having at least that amount of logins in the private login
   * vault.
   *
   * @generated from enum value: COR_LOGINS_TOTAL_1 = 4000000;
   */
  COR_LOGINS_TOTAL_1 = 4000000,

  /**
   * @generated from enum value: COR_LOGINS_TOTAL_2 = 4000001;
   */
  COR_LOGINS_TOTAL_2 = 4000001,

  /**
   * @generated from enum value: COR_LOGINS_TOTAL_4 = 4000002;
   */
  COR_LOGINS_TOTAL_4 = 4000002,

  /**
   * @generated from enum value: COR_LOGINS_TOTAL_8 = 4000003;
   */
  COR_LOGINS_TOTAL_8 = 4000003,

  /**
   * @generated from enum value: COR_LOGINS_TOTAL_16 = 4000004;
   */
  COR_LOGINS_TOTAL_16 = 4000004,

  /**
   * @generated from enum value: COR_LOGINS_TOTAL_32 = 4000005;
   */
  COR_LOGINS_TOTAL_32 = 4000005,

  /**
   * @generated from enum value: COR_LOGINS_TOTAL_64 = 4000006;
   */
  COR_LOGINS_TOTAL_64 = 4000006,

  /**
   * @generated from enum value: COR_LOGINS_TOTAL_128 = 4000007;
   */
  COR_LOGINS_TOTAL_128 = 4000007,

  /**
   * @generated from enum value: COR_LOGINS_TOTAL_256 = 4000008;
   */
  COR_LOGINS_TOTAL_256 = 4000008,

  /**
   * @generated from enum value: COR_LOGINS_TOTAL_512 = 4000009;
   */
  COR_LOGINS_TOTAL_512 = 4000009,

  /**
   * @generated from enum value: COR_LOGINS_TOTAL_1024 = 4000010;
   */
  COR_LOGINS_TOTAL_1024 = 4000010,

  /**
   * Granted when writing the backup code to the meta vault
   *
   * @generated from enum value: COR_STORE_BACKUP_CODE_META_VAULT = 4000011;
   */
  COR_STORE_BACKUP_CODE_META_VAULT = 4000011,

  /**
   * Granted when the user links a login to a personal vault or team
   *
   * @generated from enum value: COR_LINKED_LOGIN_CREATE_PERSONAL = 4000012;
   */
  COR_LINKED_LOGIN_CREATE_PERSONAL = 4000012,

  /**
   * @generated from enum value: COR_LINKED_LOGIN_CREATE_TEAM = 4000013;
   */
  COR_LINKED_LOGIN_CREATE_TEAM = 4000013,

  /**
   * DEPRECATED: Geo unlock was removed
   * Granted when the user adds a geo unlock region
   *
   * @generated from enum value: COR_ADD_GEO_UNLOCK_REGION = 4000014 [deprecated = true];
   * @deprecated
   */
  COR_ADD_GEO_UNLOCK_REGION = 4000014,

  /**
   * Granted on creation of the first share secret
   *
   * @generated from enum value: COR_LOGIN_CREATE_SHARE_SECRET = 4000304;
   */
  COR_LOGIN_CREATE_SHARE_SECRET = 4000304,

  /**
   * ios
   * Granted after the showing the guid to enable autofill.
   *
   * @generated from enum value: IOS_AUTOFILL_GUIDE_SETUP = 5000000;
   */
  IOS_AUTOFILL_GUIDE_SETUP = 5000000,

  /**
   * Granted after autofill has been enabled and at least used it once.
   *
   * @generated from enum value: IOS_AUTOFILL_ENABLE = 5000001;
   */
  IOS_AUTOFILL_ENABLE = 5000001,

  /**
   * Granted when a user does not have a secure lock screen, but enforcement is not enabled
   *
   * @generated from enum value: IOS_SECOND_FACTOR_ENFORCEMENT_GRANDFATHERED = 5000100;
   */
  IOS_SECOND_FACTOR_ENFORCEMENT_GRANDFATHERED = 5000100,

  /**
   * cnb
   * All import achievements are granted after successfully importing from the specified product.
   *
   * @generated from enum value: CNB_IMPORT_CXF = 6000100;
   */
  CNB_IMPORT_CXF = 6000100,
}

/**
 * Describes the enum domain.Achievement.
 */
export const AchievementSchema: GenEnum<Achievement> = /*@__PURE__*/
  enumDesc(file_achievements, 0);

